export const PERSONAL_DETAILS_PATH = '/personal-details';
export const EDIT_PERSONAL_INFORMATION_PATH = '/personal-details/personal-information';
export const ADD_PHONE_NUMBER_PATH = '/personal-details/add/phone-number';
export const EDIT_PASSWORD_PATH = '/personal-details/edit-password';
export const EDIT_HOME_ADDRESS_PATH = '/personal-details/edit/home-address';
export const EDIT_MAILING_ADDRESS_PATH = '/personal-details/edit/mailing-address';
export const EDIT_DELIVERY_ADDRESS_PATH = '/personal-details/edit/delivery-address';

export const routePaths = {
  PERSONAL_DETAILS_PATH,
  EDIT_PERSONAL_INFORMATION_PATH,
  EDIT_PASSWORD_PATH,
  ADD_PHONE_NUMBER_PATH,
  EDIT_HOME_ADDRESS_PATH,
  EDIT_MAILING_ADDRESS_PATH,
  EDIT_DELIVERY_ADDRESS_PATH
};

export default routePaths;
